import React from 'react';
import { CustomLink } from '../components/CustomLink';
import Footer from '../components/partials/Footer';

const NotFound = () => {
	return (
		<div className='relative'>
			<div
				style={{ backgroundColor: '#f9f9f9' }}
				className='w-full h-screen flex flex-col justify-center items-center'
			>
				<h1 className='text-4xl md:text-7xl font-bold text-gray-600'>
					404 | Notfound
				</h1>
				<CustomLink
					to='/'
					className='bg-dark text-white rounded-lg py-3 px-5'
				>
					Back To Home
				</CustomLink>
			</div>
			<Footer />
		</div>
	);
};

export default NotFound;
